/*
 * react-data-export depends on tempa-xlsx, whose bundled writer references
 * a few global identifiers without declarations (e.g. _hashIndex).
 * In strict/bundled runtimes this can throw ReferenceError and break exports.
 *
 * We pre-seed those globals once at app startup so all legacy Excel exports
 * keep working until the export stack is fully migrated off react-data-export.
 */
(function initTempaXlsxGlobals() {
  if (typeof globalThis === 'undefined') {
    return;
  }
  if (typeof globalThis.QUOTE === 'undefined') {
    globalThis.QUOTE = '"';
  }
  if (typeof globalThis._hashIndex === 'undefined') {
    globalThis._hashIndex = {};
  }
  if (typeof globalThis._listIndex === 'undefined') {
    globalThis._listIndex = [];
  }
  if (typeof globalThis.style_builder === 'undefined') {
    globalThis.style_builder = null;
  }
})();

